import { Codes, MarketplaceWorkerNotification } from '../smartsend/SmartSendSocketsModels';

export const GetSocketMessage = (details: MarketplaceWorkerNotification | undefined) => {
  if (details?.Code?.startsWith('USER-ACTION')) {
    return 'Action Required';
  }

  switch (details?.Code) {
    case Codes.SyncShippedAuthenticated:
      return 'Connected...';
    case Codes.SyncShippedStarted:
      return 'Syncing...';
    case Codes.SyncShippedFinished:
      return 'Completed';
    case Codes.ImportAuthenticated:
      return 'Connected...';
    case Codes.ImportStarted:
      return 'Importing...';
    case Codes.ImportFinished:
      return 'Completed';
    case Codes.RuleApplierStarted:
      return 'Applying Rules...';
    case Codes.RuleApplierFinished:
      return 'Rules Applied';
    case Codes.PersistenceStarted:
      return 'Saving Items...';
    case Codes.PersistenceFinished:
      return 'Items Saved';
    case Codes.CustomError:
      return 'Account Issue';
    case Codes.ImportThrottled:
      return 'Processing...';
    case Codes.SetupRequired:
      return 'Configure Account';
    case Codes.AuthorisationFailed:
    case Codes.CredentialsExpired:
    case Codes.ScopeMissing:
      return 'Relink Account';
    default:
      return null;
  }
};
